const OPEN_GUMIGPS_CONFIG = { loginKey: "pjtPKKVqTw8HsAp9EV9&WNCNEUgMJmj3", apiId: "Deniz Ördek", apiBaseUrl: "https://spyduck-8887f.ew.r.appspot.com/api" }
export default OPEN_GUMIGPS_CONFIG